export class AlertWrapper {
    target;
    location;
    name;
    severity;
    category;
    constructor(name, category, severity, target, location) {
        this.name = name;
        this.category = category;
        this.severity = severity;
        this.target = target;
        this.location = location;
    }
    get value() {
        return Boolean(this.target[this.location]);
    }
    set value(value) {
        this.target[this.location] = Number(value);
    }
}
